import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/bar', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0a0a0c] flex items-center justify-center">
      <div className="text-amber-400 text-sm tracking-widest">
        驗證中，請稍候...
      </div>
    </div>
  );
}